import React, {useState} from 'react';

function ResetPasswordMain({ handleResetPassword }) {
    const [formData, setFormData] = useState({ password: '', repeatPassword: '' });
    const [errorAlert, setErrorAlert] = useState(false)

    const showErrorAlert = () => {
        setErrorAlert(true)

        setTimeout(function() {
            setErrorAlert(false)
        }, 3500)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const { password, repeatPassword } = formData;

        if (password === repeatPassword) {
            handleResetPassword(password);
        } else {showErrorAlert()}
    };

    return (
        <>
            <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 relative">
                <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
                    <img className="w-full h-full object-cover" data-alt="Abstract dark racing track with motion blur" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBKqQz6UAyrrEQWu4miwbFSmBOAlwzRfW8LLitvVxaVavpDtcuSlJgt-iItw2dUTQ-BYp6frvs4tu9gDOpPaQAreXd6GJRA1iqmChzNW4UD6BJPqQ3O7SNvDKyt7hfWEQ8lrf1_zImFpC4VmbH_XHzSCl4ue-huzMhh0Gz34vH__A3cZ82mfq0uyAPfEEZ2JgDPqzz98o48HYWN4Rl2nXKP74ERx4YWVaMNSem4BNfOa2iKnNSfm2O7czVGrhjBFmEyFjdmUilj2Jo" />
                </div>
                <div className="w-full max-w-[440px] z-10">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center size-16 rounded-full bg-primary/10 mb-6 border border-primary/20">
                            <span className="material-symbols-outlined text-primary text-3xl">lock_reset</span>
                        </div>
                        <h1 className="text-white tracking-tight text-[32px] font-bold leading-tight pb-2">Reset Your Password</h1>
                        <p className="text-white/60 text-base font-normal leading-normal">Enter a new secure password for your driver profile.</p>
                    </div>
                    <div className="glass-card rounded-xl p-8 shadow-2xl">
                        <form className="space-y-6">
                            <div className="flex flex-col gap-2">
                                <label className="text-white/70 text-sm font-medium">New Password</label>
                                <div className="relative">
                                    <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">lock</span>
                                    <input onChange={e => setFormData({...formData, password: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="••••••••" required="" type="password" />
                                </div>
                                <p className="text-[11px] text-white/30">Must be at least 8 characters long.</p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <label className="text-white/70 text-sm font-medium">Confirm New Password</label>
                                <div className="relative">
                                    <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">shield_lock</span>
                                    <input onChange={e => setFormData({...formData, repeatPassword: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="••••••••" required="" type="password" />
                                </div>
                            </div>
                            <div className="pt-2">
                                <button onClick={handleSubmit} className="w-full bg-primary hover:bg-primary/80 text-white font-bold py-4 rounded-lg shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 group" type="submit">
                                    Update Password
                                    <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">check_circle</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>

            {errorAlert && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">The two passwords are not the same</span>}
        </>
    );
}

export default ResetPasswordMain;